import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "treebal-close" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["search-field", {
      empty: _ctx.isEmpty,
      expended: _ctx.isExpended(),
    }]),
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.expend && _ctx.expend(...args)))
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: _ctx.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCacheValue) = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.typing && _ctx.typing(...args))),
      onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.focusOut && _ctx.focusOut(...args))),
      name: "search"
    }, null, 40, _hoisted_1), [
      [_vModelText, _ctx.searchCacheValue]
    ]),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
    }, _hoisted_3)
  ], 2))
}